import {
	type IAirplaneInfo,
	useAirplaneList,
} from "@/pages/PlanDetail/hooks/useAirplane.js";
import { hooks } from "@/store.js";
import {
	Autocomplete,
	AutocompleteItem,
	DateInput,
	DatePicker,
} from "@heroui/react";
import { memo, useState, type ReactNode } from "react";
import isEqual from "react-fast-compare";
import AirplaneCard from "../AirplaneCard/index.jsx";
import { useAsyncList } from "@react-stately/data";
import dayjs from "dayjs";
import { useMemoizedFn } from "ahooks";
import axios from "axios";

const validateFlightNumber = (flightNumber: string): boolean => {
	// 匹配2-3个字母后跟3-4个数字的格式
	const flightNumberRegex = /^[A-Z]{2,3}\d{3,4}$/;
	return flightNumberRegex.test(flightNumber.toUpperCase());
};

type IRecord = IAirplaneInfo & {
	// no: string;
	footer?: ReactNode;
	onClick?: () => void;
	headerRight?: ReactNode;
	value: string;
	// date: string;
};
const AirPlaneAutocomplete = memo(() => {
	const list = useAirplaneList({ withInfo: true });

	const myFilter = (textValue: string, inputValue: string) => {
		if (inputValue.length === 0) {
			return true;
		}

		const info = list.find((i) => i.value === textValue) || {};

		const curTextValue = Object.values(info)
			.join("_")
			.normalize("NFC")
			.toLocaleLowerCase();
		const curInputValue = inputValue.normalize("NFC").toLocaleLowerCase();

		return curTextValue.includes(curInputValue);
	};
	// const [date, setDate] = useState("");

	// const list = useAsyncList<IRecord>({
	// 	async load({ signal, filterText }) {
	// 		const items: IRecord[] = [];
	// 		if (filterText?.length && date && validateFlightNumber(filterText)) {
	// 			console.log(date, filterText);
	// 			const carrierCode = filterText.match(/^[A-Z]{2,3}/)?.[0] || "";
	// 			const flightNumber = filterText.match(/\d{3,4}$/)?.[0] || "";

	// 			const res = await axios.get<{
	// 				meta: {
	// 					count: 1;
	// 					links: {
	// 						self: "https://test.api.amadeus.com/v2/schedule/flights?carrierCode=MF&flightNumber=891&scheduledDepartureDate=2025-04-04";
	// 					};
	// 				};
	// 				data: [
	// 					{
	// 						type: "DatedFlight";
	// 						scheduledDepartureDate: "2025-04-04";
	// 						flightDesignator: { carrierCode: "MF"; flightNumber: 891 };
	// 						flightPoints: [
	// 							{
	// 								iataCode: "XMN";
	// 								departure: {
	// 									timings: [
	// 										{ qualifier: "STD"; value: "2025-04-04T17:45+08:00" },
	// 									];
	// 								};
	// 							},
	// 							{
	// 								iataCode: "DPS";
	// 								arrival: {
	// 									timings: [
	// 										{ qualifier: "STA"; value: "2025-04-04T23:05+08:00" },
	// 									];
	// 								};
	// 							},
	// 						];
	// 						segments: [
	// 							{
	// 								boardPointIataCode: "XMN";
	// 								offPointIataCode: "DPS";
	// 								scheduledSegmentDuration: "PT5H20M";
	// 							},
	// 						];
	// 						legs: [
	// 							{
	// 								boardPointIataCode: "XMN";
	// 								offPointIataCode: "DPS";
	// 								aircraftEquipment: { aircraftType: "738" };
	// 								scheduledLegDuration: "PT5H20M";
	// 							},
	// 						];
	// 					},
	// 				];
	// 			}>("https://flight-detail.api.pmlife.top", {
	// 				params: {
	// 					scheduledDepartureDate: date,
	// 					carrierCode,
	// 					flightNumber,
	// 				},
	// 			});
	// 			items.push({
	// 				value: filterText,

	// 				// "company": "厦航",
	// 				// "model": "波音737-800",
	// 				// "startPosition": "XMN高崎T3",
	// 				// "endPosition": "DPS巴厘岛I",
	// 				// "startTime": "17:45",
	// 				// "endTime": "23:05"

	// 				// stay,
	// 				// company,
	// 				// no,
	// 				// model,
	// 				// headerRight,
	// 				// startPosition,
	// 				// endPosition,
	// 				// date,
	// 				// startTime,
	// 				// endTime,
	// 			});
	// 		}
	// 		return {
	// 			items,
	// 		};
	// 	},
	// });

	return (
		<>
			{/* <DatePicker
				onChange={(e) => (e ? setDate(`${e.year}-${e.month}-${e.day}`) : "")}
				isRequired
				name="date"
				radius="full"
				className="mb-4"
				size="lg"
				label={<span className="text-xs">日期</span>}
				classNames={{
					inputWrapper: "px-4",
					input: "text-sm",
				}}
			/> */}
			<Autocomplete
				defaultFilter={myFilter}
				label="航班号"
				isRequired
				name="no"
				radius="full"
				autoFocus
				placeholder="AB1234"
				listboxProps={{
					hideSelectedIcon: true,
					itemClasses: {
						base: [
							"rounded-2xl",
							"transition-opacity",
							"data-[pressed=true]:opacity-70",
							"data-[hover=true]:bg-default-100",
							"data-[selectable=true]:focus:bg-default-100",
							"data-[focus-visible=true]:ring-default-500",

							"data-[selected=true]:border-2",
							"data-[selected=true]:border-black",
						],
					},
				}}
				// inputValue={list.filterText}
				// isLoading={list.isLoading}
				// items={list.items}
				// onInputChange={list.setFilterText}
			>
				{/* {(item) => (
					<AutocompleteItem key={item.value} className="capitalize">
						<AirplaneCard
							{...item}
							no={item.value}
							date={date || "2000-01-01"}
						/>
					</AutocompleteItem>
				)} */}
				{list.map((item) => {
					return (
						<AutocompleteItem
							key={item.value}
							// textValue={`${item.value}(${item.startPosition}-${item.endPosition})`}
							textValue={item.value}
						>
							<AirplaneCard {...item} no={item.value} date={"2000-01-01"} />
						</AutocompleteItem>
					);
				})}
			</Autocomplete>
		</>
	);
}, isEqual);

export default AirPlaneAutocomplete;
